import { useCallback } from 'react';
import useEnvironmentsData from './useEnvironmentsData';

// An environment is considered "initializing" until its first sync completes.
// The shared [ENVIRONMENTS] cache (kept warm by useEnvironmentsPolling in
// AppShell) exposes lastSyncedAt, which is set only once data has synced.
const useInitializingEnvs = () => {
  const { data: environments } = useEnvironmentsData();

  const isEnvInitializing = useCallback(
    (envId: string) => {
      const env = environments?.find((environment) => environment.id === envId);
      return !!env && !env.lastSyncedAt;
    },
    [environments],
  );

  return { isEnvInitializing };
};

export default useInitializingEnvs;
